import { Component } from '@angular/core';

@Component({
  selector: 'login',
  styleUrls: ['./login.component.less'],
  templateUrl: './login.component.html'
})
export class LoginComponent { }



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts